import { RoomPanel } from '$lib/enums/room-panel.enums';
import type { Settings } from '$lib/types';
import { MessageLayout } from '$lib/enums';

export const DEFAULT_SETTINGS: Settings = {
	themeId: undefined,
	useSystemTheme: true,
	lightThemeId: undefined,
	darkThemeId: undefined,
	twitterEmoji: false,
	pageZoom: 100,
	hideActivity: false,

	roomPanel: RoomPanel.MEMBERS,
	memberSortFilterIndex: 0,
	enterForNewline: false,
	messageLayout: MessageLayout.MODERN,
	messageSpacing: '400',
	hideMembershipEvents: false,
	hideNickAvatarEvents: false,
	mediaAutoLoad: true,
	urlPreview: true,
	encUrlPreview: false,
	showHiddenEvents: false,
	legacyUsernameColor: false,

	showNotifications: true,
	isNotificationSounds: true,

	hour24Clock: false,
	dateFormatString: 'D MMM YYYY',

	developerTools: false
};

export const DEFAULT_CALL_PREFERENCES = {
	microphone: true,
	video: false,
	sound: true
} as const;
